import Loading from '../../../Common/Loading';
import { useFetalDeathChartsDataContext } from './hooks/useFetalDeathChartsDataContext';
import { FetalDeaths } from './FetalDeaths';
import { MotherAge } from './MotherAge';
import { DeathsInRelationToChildbirth } from './DeathsInRelationToChildbirth';
import { TypesOfPregnancy } from './TypesOfPregnancy';
import { Weight } from './Weight';
import { PregnancyMonths } from './PregnancyMonths';

export const Charts = () => {
    const { isLoading } = useFetalDeathChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="w-100">
                <FetalDeaths />
            </div>

            <div className="charts-side-by-side-dashboards">
                <DeathsInRelationToChildbirth />
                <TypesOfPregnancy />
                <Weight />
            </div>
            <div className="charts-side-by-side-dashboards">
                <PregnancyMonths />
                <MotherAge />
            </div>
        </>
    );
};
